/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { _fn } from '@mairistem/administres-utils';
import { Liste } from '@mairistem/liste';

import type { Specialite } from '@/types';

import SpecialiteListeTable from './SpecialiteListeTable';

interface Props {
  /** Nombre de lignes */
  count?: number;
  /** État du chargement */
  loading?: boolean;
  /** Callback appelé lors du chargement de la liste */
  onLoad?: () => void;
  /** Callback appelé lors d'une saisie dans la barre de recherche */
  onSearch?: (value: string) => Promise<void>;
  /** Callback appelé lors d'un filtrage sur la liste */
  onSort?: () => void;
  /** Nombre de lignes par page */
  perPage?: number;
  /** Données de la liste */
  specialites?: Specialite[];
  /** Callback appelé lors de la sélection d'un item */
  onSelect?: (qualification: Specialite) => void;
  /** Callback appelé lors de la sauvegarde */
  onSave?: (qualification: Specialite) => void;
  /** Spécialité sélectionnée */
  selectedSpecialite?: Specialite;
  /** Callback appelé lors de la réinitialisation des lignes */
  resetSelectedItems?: (qualification: Specialite) => void;
}

const SpecialiteListe = (props: Props) => {
  const {
    count = 0,
    perPage = 50,
    specialites = [],
    selectedSpecialite = {},
    loading = false,
    onLoad = null,
    onSearch = null,
    onSort = null,
    onSelect = null,
    onSave = null,
    resetSelectedItems = null,
    ...rest
  } = props;

  const handleSelect = React.useCallback(
    (qualification: Specialite, qualifications: Specialite[]) => {
      _fn(onSelect, !_.isEmpty(qualifications) ? qualification : {});
    },
    [onSelect],
  );

  return (
    <Liste title="" onSearch={onSearch} loading={loading} searchable {...rest}>
      <Liste.Content>
        <SpecialiteListeTable
          items={specialites}
          count={count}
          loading={loading}
          onLoad={onLoad}
          onSelect={handleSelect}
          perPage={perPage}
          onSort={onSort}
          onSave={onSave}
          selectedSpecialite={selectedSpecialite}
          resetSelectedItems={resetSelectedItems}
        />
      </Liste.Content>
    </Liste>
  );
};

export default SpecialiteListe;
